export default __webpack_public_path__ + "static/media/36605-shopping-cart.78df5b83.webp";